import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../assets/css/signin.scss'
import { Link, useNavigate } from 'react-router-dom';
import googleIcon from '../assets/images/signin/google.png'
import linkedIcon from '../assets/images/signin/linkedin.png'
import companyLogo from '../assets/images/signin/logo-dark-copy.png'
import { postSignInUserData } from './redux/action';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as HeaderAuthentication from '../components/HeaderAuthentication';
import CryptoJS from "crypto-js";

const SignIn = () => {
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const tokenClientRef = useRef(null);
    let hideSwal = false;

    const [planExpired, setPlanExpired] = useState(false);
    const [expireDetails, setExpireDetails] = useState("");

    const [formData, setFormData] = useState({
        email: '',
        pswd: ''
    });

    const [errors, setErrors] = useState({});
    const [rememberMe, setRememberMe] = useState(false); // State for Remember Me checkbox

    // AUTO LOGIN WHEN ?email= IS PRESENT
useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const autoEmail = urlParams.get("email");

    if (autoEmail) {
        console.log("Auto-login for:", autoEmail);

        const loginPayload = {
            email: autoEmail,
            pswd: "",     // social login = empty password
            flagged: true
        };

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(loginPayload),
        };

        dispatch(postSignInUserData(requestOption, true, autoEmail, "", ""));
    }
}, []);


    // Load credentials from localStorage on mount
    useEffect(() => {
        const rememberedCredentials = JSON.parse(localStorage.getItem("rememberedCredentials"));
        if (rememberedCredentials) {
            setFormData({
                EmailID: rememberedCredentials.email,
                Password: rememberedCredentials.pswd
            });
            setRememberMe(true);
        }
    }, []);

    // Handle "Remember me" toggle
    const toggleRememberMe = () => {
        setRememberMe(!rememberMe);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        }
        if (!formData.pswd.trim()) {
            newErrors.pswd = 'Password is required';
        }
        return newErrors;
    };

    const handleLogin = (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const signInData = {
            email: formData.email,
            pswd: formData.pswd,
            flagged:true
        };

        if (rememberMe) {
            const credentials = {
                email: formData.email,
                pswd: formData.pswd,
                remember: rememberMe
            };
            localStorage.setItem("rememberedCredentials", JSON.stringify(credentials));
        } else {
            localStorage.removeItem("rememberedCredentials");
        }
        addSignIn(signInData);
        // let requestOption = {
        //     method: "POST",
        //     mode: "cors",
        //     headers: HeaderAuthentication.postAuthOfLeadMerge,
        //     body: JSON.stringify(signInData),
        // };

        // dispatch(postSignInUserData(requestOption, navigate, hideSwal));
    };
    const handlePostLoginNavigation = (userData) => {
    if (!userData) return;

    const user_role = userData?.role?.toLowerCase()?.trim();
    sessionStorage.setItem("SignInDetails", JSON.stringify([userData]));

    switch (user_role) {
        case "b2buser":
            window.location.href = "/raiserequest"; // full redirect
            break;
        case "client":
        case "admin":
        case "bde": // lowercase
            window.location.href = "/dashboard";
            break;
        default:
            console.error("Unknown user role:", userData?.role);
            break;
    }
};





    const addSignIn = (data) => {
        console.log(data, 'data')
        const signInData = {
            email: data.email,
            pswd: data.pswd,
            flagged:true
        };

        if (rememberMe) {
            const credentials = {
                email: data.email,
                pswd: data.pswd,
                remember: rememberMe
            };
            localStorage.setItem("rememberedCredentials", JSON.stringify(credentials));
        } else {
            localStorage.removeItem("rememberedCredentials");
        }

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(signInData),
        };
        dispatch(postSignInUserData(requestOption, hideSwal, data.email, data.name, data.phoneNumber))
        .then(res => handlePostLoginNavigation(res));
        // dispatch(postSignInUserData(requestOption, hideSwal, data.email, data.name, data.phoneNumber));
        
    };

useEffect(() => {
    if (window.google?.accounts?.oauth2) {
        tokenClientRef.current = window.google.accounts.oauth2.initTokenClient({
            client_id: '762425997431-plapsidtr0nm2kjfkc9vrk6vcv2lsfa2.apps.googleusercontent.com',
            scope: 'openid profile email https://www.googleapis.com/auth/user.phonenumbers.read',
            callback: async (tokenResponse) => {

                try {
                    // Call People API to get phone number
                    const res = await fetch('https://people.googleapis.com/v1/people/me?personFields=phoneNumbers,emailAddresses,names', {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.access_token}`,
                        },
                    });

                    const data = await res.json();

                    // Extract name, email, and phone number
                    const name = data.names ? data.names[0].displayName : '';
                    const email = data.emailAddresses ? data.emailAddresses[0].value : '';
                    const phoneNumber = data.phoneNumbers ? data.phoneNumbers[0].value : '';

                    const userData = {
                        name,
                        email,
                        // "mobile_code": "",
                        phoneNumber,
                        // "company_name": "",
                    };
                    hideSwal = true;
                    addSignIn(userData);

                } catch (error) {
                    console.error('Failed to fetch phone number:', error);
                }
            },
        });
    }
}, []);

const handleGetPhone = () => {
    if (tokenClientRef.current) {
        tokenClientRef.current.requestAccessToken();
    } else {
        console.error("Token client not initialized");
    }
};

    // #region upgrade plan
function upgrade_plan(){
    const key = "lm-oap-b2b-lobotus";

    const decryptedText = xorDecrypt(expireDetails, key);
    const user_data = JSON.parse(decryptedText);
    console.log(user_data, "user_data")
    
    const params = new URLSearchParams(user_data).toString();
    const encrypted = CryptoJS.AES.encrypt(params, 'leadmerge_id_upgrade').toString();
    console.log(encrypted, "encrypted")
    const url = `https://www.leadmerge.com/pricing.html?data=${encodeURIComponent(encrypted)}`;
    // const url = `http://localhost/leadmerge/pricing.html?data=${encodeURIComponent(encrypted)}`;

    // Open in a new tab
    window.open(url, '_blank');
}
// #endregion


function xorDecrypt(base64CipherText, key) {
  const encryptedBytes = atob(base64CipherText);
  const keyBytes = new TextEncoder().encode(key);

  const resultBytes = new Uint8Array(encryptedBytes.length);
  for (let i = 0; i < encryptedBytes.length; i++) {
    const encryptedCharCode = encryptedBytes.charCodeAt(i);
    const keyByte = keyBytes[i % keyBytes.length];
    resultBytes[i] = encryptedCharCode ^ keyByte;
  }

  return new TextDecoder("utf-8").decode(resultBytes);
}

    return (
        <Container fluid className="signin-container">
            <Row className="signin-row">
                {/* Left Column - Image */}
                <Col md={6} className="signin-first-col">
                    <img src={companyLogo} className='signinCompanyLogo' alt="" />
                    <dotlottie-player
                        src="https://lottie.host/38083418-3526-4b48-947a-c2f397e7f5df/uJRHRxuGKS.lottie"
                        background="transparent"
                        speed="1"
                        loop
                        autoplay
                        className='lottie-img'
                    ></dotlottie-player>
                </Col>

                {/* Right Column - Form */}
                <Col md={6} className="signin-second-col">
                    <h3 className="mb-4 text-center">Sign In</h3>
                    <Form className='signin-form-container'>
                        <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Control
                                type="email"
                                placeholder="Enter email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                            {errors.email && <div className="text-danger">{errors.email}</div>}
                        </Form.Group>
                        <Form.Group controlId="formPassword" className="position-relative">
                            <Form.Control
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter password"
                                name="pswd"
                                value={formData.pswd}
                                onChange={handleChange}
                                className="pe-5" 
                            />
                            <i
                                className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} toggle-eye`}
                                onClick={() => setShowPassword(!showPassword)}
                            ></i>
                            {errors.pswd && <div className="text-danger mt-1">{errors.pswd}</div>}
                        </Form.Group>

                        <div className="forgot-pass-n-remind-me">
                            <div className="signIn-footer ">
                                <div className="create-account-div d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        checked={rememberMe}
                                        onChange={toggleRememberMe}
                                    />&nbsp;&nbsp;
                                    <div
                                        className="login-remember-me"
                                    >
                                        Remember my preferences
                                    </div>
                                </div>
                            </div>
                            <div className="forget-pasword-div">
                                <Link
                                    to="/forget-password"
                                    className="lm-pswd-reset"
                                >
                                    Forgot Password?
                                </Link>
                            </div>
                        </div>

                        <Button variant="primary" type="submit" className="w-100" onClick={handleLogin}>
                            Sign In
                        </Button>

                        <div className="divider-container">
                            <div className="line"></div>
                            <p className="text">Or continue with</p>
                            <div className="line"></div>
                        </div>
                        {planExpired && <div>
                            <p className='m-0 expire-link'>Plan expired. Do you want to upgrade.? <span className='click-link' onClick={upgrade_plan}>Click Here</span></p>
                        </div>}
                        {/* {<div>
                            <p className='m-0 expire-link'>Plan expired. Do you want to upgrade.? <span className='click-link' onClick={upgrade_plan}>Click Here</span></p>
                        </div>} */}
                        <div className='lm-login-btns-section'>
                            <div className='btn-div' onClick={handleGetPhone}>
                                <img src={googleIcon} alt="" />
                            </div>
                            <div
  className="btn-div"
  style={{ cursor: "pointer" }}
  onClick={() => {
    const clientId = "86opkgjrw1jcp4";
    const redirectUri = encodeURIComponent(
      "https://gfcb8ed8eb8355a-st94sy8hnd7n7e0g.adb.ap-mumbai-1.oraclecloudapps.com/ords/leadmerge/oauth/linkedin/callback"
    );
    const state = "leadmerge_login";

    const linkedInAuthUrl =
      `https://www.linkedin.com/oauth/v2/authorization` +
      `?response_type=code` +
      `&client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&state=${state}` +
      `&scope=openid%20profile%20email`;

    window.location.href = linkedInAuthUrl;
  }}
>
  <img src={linkedIcon} alt="LinkedIn Login" />
</div>

                        </div>
                        <div className='signin-signup-link'>
                            <p>Don't have an account? <Link to='/signup'> Sign Up </Link></p>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default SignIn;
